module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/imac-c98000d11af657d1754224467b934c3d.svg";